import { useEffect } from 'react';
import { DialogFormV2 } from '@centerpiece/components';
import { useCreateProjectTemplateMutation } from 'store/api';
import { useProjectTemplateForm } from 'jformik/useProjectForm';
import { useNavigate } from 'react-router-dom';
import { useTutorialContext } from 'tutorials/tutorial.context';
import { toast } from 'react-toastify';

export interface CreateTemplateDialogueProps {
  open: boolean;
  close: Function;
  category?: string;
}

export const CreateTemplateDialogue = ({
  open,
  close,
  category,
}: CreateTemplateDialogueProps) => {
  const navigate = useNavigate();

  const [createProjectTemplate] = useCreateProjectTemplateMutation();
  const [templateValidation, templateForm] = useProjectTemplateForm({});
  const { state, setState } = useTutorialContext();
  useEffect(() => {
    if (open && state.tourActive) {
      setState(currState => ({
        ...currState,
        run: true,
      }));
    }

    return function cleanup() {
      setState(currState => ({ ...currState, run: false }));
    };
    // eslint-disable-next-line
  }, [open]);
  return (
    <DialogFormV2
      open={open}
      // onHelp={category === 'Custom' ? undefined : () => setState({ run: true, stepIndex: 0, steps: createProjectSteps() })}
      title={'Create a Template Project'}
      onClose={() => close()}
      // subtitle={`Owner: @${user?.firstname} ${user?.lastname}`}
      fullWidth={true}
      maxWidth={'md'}
      scroll={'body'}
      initialValues={() => ({
        name: '',
        description: '',
      })}
      handleSubmit={async (values, formik) => {
        try {
          const newTemplate = await createProjectTemplate({
            ...values,
            type: values?.type?.id,
            market_segment: values?.market_segment?.id,
          }).unwrap();
          navigate(`/project_template/${newTemplate?.project}`);
          close();
          toast.info('Template created successfuly');
        } catch (error) {
          toast.error('Unable to create project template');
        }
      }}
      validationSchema={templateValidation}
      form={templateForm}
    />
  );
};
